/* hero-backdrop.js
 * Mouse-reactive gradient background (Aceternity "Background Gradient Animation").
 * A soft pointer blob smoothly follows the cursor across each hero. The backdrop
 * itself is pointer-events:none and sits behind the 3D bag, so it never blocks or
 * changes the way the bag is displayed — we listen on the hero section instead.
 */
(function () {
  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeroBackdrop(root) {
    var pointer = root.querySelector('[data-hero-backdrop-pointer]');
    if (!pointer || reduce) return;

    var host = root.closest('.hero-3d') || root.parentElement;
    if (!host) return;

    var curX = 0,
      curY = 0,
      tgX = 0,
      tgY = 0,
      running = false;

    function frame() {
      curX += (tgX - curX) / 20;
      curY += (tgY - curY) / 20;
      pointer.style.transform =
        'translate(' + Math.round(curX) + 'px, ' + Math.round(curY) + 'px)';
      requestAnimationFrame(frame);
    }

    function onMove(e) {
      var rect = root.getBoundingClientRect();
      var point = e.touches && e.touches[0] ? e.touches[0] : e;
      tgX = point.clientX - rect.left;
      tgY = point.clientY - rect.top;
      if (!running) {
        running = true;
        requestAnimationFrame(frame);
      }
    }

    host.addEventListener('mousemove', onMove);
    host.addEventListener('touchmove', onMove, { passive: true });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-hero-backdrop]');
    for (var i = 0; i < nodes.length; i++) initHeroBackdrop(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
